import { Button, Input, ButtonProps, InputProps } from 'antd';
import { SearchOutlined, InfoOutlined } from '@ant-design/icons';
import './styles.less';
import InputDecimal from '../InputDecimal';

type Props = {
  inputProps?: InputProps;
  buttonProps?: ButtonProps;
  inputDecimal?: boolean;
  viewIcon?: boolean;
  valueMax?: number;
  disabledInputDecimal?: boolean;
};

const InputSearch: React.FC<Props> = ({
  inputProps,
  buttonProps,
  inputDecimal,
  viewIcon,
  valueMax,
  disabledInputDecimal,
  ...props
}) => {
  return (
    <div className="input-search">
      {!inputDecimal ? (
        <Input {...inputProps} {...props} />
      ) : (
        <InputDecimal
          max={valueMax}
          disabled={disabledInputDecimal}
          {...props}
        />
      )}

      <Button
        type="primary"
        icon={
          viewIcon ? (
            <InfoOutlined style={{ fontSize: 20 }} />
          ) : (
            <SearchOutlined style={{ fontSize: 20 }} />
          )
        }
        {...buttonProps}
      />
    </div>
  );
};

export default InputSearch;
